import { Hidden, HiddenProps } from '@material-ui/core';
import React from 'react';

type HiddenWithChildrenProps = React.ComponentType<HiddenProps & {children: JSX.Element}>

const HiddenWithChildren : HiddenWithChildrenProps = Hidden as unknown as HiddenWithChildrenProps

export default HiddenWithChildren;